import {Component, EventEmitter, Inject, OnDestroy, Output} from '@angular/core';
import {OverlayHelper} from '../../../../helper/overlay.helper';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { BaseCustomDialog } from '../base-custom-dialog';

@Component({
  selector: 'fi-alert-dialog',
  templateUrl: './alert-dialog.component.html',
  styleUrls: ['./alert-dialog.component.scss'],
  standalone: false,
})
export class AlertDialogComponent extends BaseCustomDialog implements OnDestroy {
  @Output() popupClosed = new EventEmitter<boolean>();
  title = 'Alert';
  description = '';
  buttonText = 'OK';
  buttonClass = '';
  buttonIcon = '';

  constructor(
    public dialogRef: MatDialogRef<AlertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: {
      titleSnippet?: string,
      descriptionSnippet?: string,
      confirmButtonSnippet?: string,
      confirmButtonClass?: string,
      confirmButtonIcon?: string,
    },
  ) {
    super(dialogRef);
    if (dialogData?.titleSnippet) {
      this.title = dialogData.titleSnippet;
    }
    if (dialogData?.descriptionSnippet) {
      this.description = dialogData.descriptionSnippet;
    }

    if (dialogData?.confirmButtonSnippet) {
      this.buttonText = dialogData.confirmButtonSnippet;
    }

    if (dialogData?.confirmButtonClass) {
      this.buttonClass = dialogData.confirmButtonClass;
    }
    if (dialogData?.confirmButtonIcon) {
      this.buttonIcon = dialogData.confirmButtonIcon;
    }
  }

  ngOnDestroy(): void {
    OverlayHelper.unfixBody();
  }

  closeDialog(confirm: boolean = false): void {
    this.popupClosed.emit(true);
    this.clearClassAndCloseDialog(this.dialogRef, true);
    this.dialogRef.close(confirm);
  }


  confirm(): void {
    this.clearClassAndCloseDialog(this.dialogRef, true);
  }

  onClosePopup(confirm: boolean = false): void {
    this.closeDialog(confirm);
  }

}
